// extracted by mini-css-extract-plugin
export default {"header":"Header_header__AjCdv","logo":"Header_logo__zIrot","nav":"Header_nav__av5Du"};